<template>
  <div class="mb-5">
    <div class="text-h5 font-weight-bold my-4">Update Move-In Instructions</div>
    <v-form v-if="moveInInstructions">
      <froala
        data-testid="admin-move-in-instructions-froala-content"
        class="admin-move-in-instructions-froala-content"
        :tag="'textarea'"
        :config="froalaConfig"
        heightMin=500
        id="move-in-content"
        v-model="moveInInstructions.instructions"
      />
      <div
        v-if="moveInInstructions.id"
        class="text-body-2 mt-3 pb-4"
        data-testid="updated-at"
      >
        This facility's move-in instructions last updated {{ timestamp(moveInInstructions.updated_at) }}
      </div>
      <v-divider />
      <v-btn
        data-testid="add-instructions-btn"
        class="add-instructions-btn mt-4"
        color="primary"
        :loading="loading"
        @click="handleInstructions"
      >
        Submit
      </v-btn>
    </v-form>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "MoveInInstructions",
  data() {
    return {
      loading: false
    };
  },
  methods: {
    handleInstructions() {
      this.moveInInstructions.id ? this.updateInstructions() : this.createInstructions();
    },
    createInstructions() {
      this.loading = true;
      const payload = {
        id: this.moveInInstructions.id,
        facility_id: this.moveInInstructions.facility_id,
        instructions: this.moveInInstructions.instructions
      };
      this.$store.dispatch("createMoveInInstructions", payload)
        .then(() => {
          this.$store.dispatch("handleSuccess", "Move-In Instructions successfully updated!");
          this.loading = false;
        })
        .catch(err => {
          this.$store.dispatch("handleError", err);
          this.loading = false;
        });
    },
    updateInstructions() {
      this.loading = true;
      const payload = {
        id: this.moveInInstructions.id,
        facility_id: this.moveInInstructions.facility_id,
        instructions: this.moveInInstructions.instructions
      };
      this.$store.dispatch("updateMoveInInstructions", payload)
        .then(() => {
          this.$store.dispatch("handleSuccess", "Move-In Instructions successfully updated!");
          this.loading = false;
        })
        .catch(err => {
          this.$store.dispatch("handleError", err);
          this.loading = false;
        });
    },
    timestamp(date) {
      return moment.utc(date).local().fromNow();
    }
  },
  computed: {
    froalaConfig() {
      return {
        ...this.$store.state.application.froalaConfig,
        theme: this.$store.state.application.settings.darkTheme ? "dark" : null,
        requestHeaders: {
          Authorization: this.$store.state.auth.access_token
        }
      };
    },
    moveInInstructions() {
      return this.$store.state.facilities.moveInInstructions;
    }
  },
  beforeDestroy() {
    this.$store.dispatch("clearMoveInInstructions");
  }
};
</script>
